<script>
    import Prose from './Prose.svelte';
    import { page } from '$app/stores';

    let className = '';
    export { className as class };

    export let text = undefined;

    let resolved_text;
    $: resolved_text = text === undefined ? $page.data.faq : text;

</script>


{#if resolved_text}
<div
    class="flex flex-col gap-4 max-w-3xl {className}"
    itemscope
    itemtype="https://schema.org/FAQPage"
>
    {@html resolved_text}
</div>
{/if}
